import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import MedicalFormArea from './MedicalForm/MedicalFormArea';

const MedicalFormLanding = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('Request a Form')} | Richmond In-Store Medical Clinic</title>
        <link rel="canonical" href="https://instoremed.com/medicalform" />
        <meta
          name="description"
          content={t(
            'Request a form to be filled out by a healthcare provider for school, work, disability, insurance or other purposes. In many cases, this can be done without coming to our medical clinic in person.'
          )}
        />
      </Helmet>

      <main className="py-5">
        <div className="container">
          <div className="center mb-4">
            <h1 className="mb-3">{t('Request a Form')}</h1>
            <div className="bottom-line"></div>
            <p>{t('Need a Form Filled Out? We Can Help.')}</p>
            <p>{t('At the Richmond In-Store Medical Clinic, we offer a convenient service to help with your paperwork needs. No appointment necessary.')}</p>
          </div>
        </div>
      </main>

      <MedicalFormArea />
    </>
  );
};

export default MedicalFormLanding;
